export default __webpack_public_path__ + "static/media/Banner.52640adf.svg";